$.fn.showDialog = function() {
  return this.each(function() {
    $(this).removeClass('d-none');
    setTimeout(() => {
      $(this).find('.custom-dialog-content').removeClass('closed').addClass('open');
    }, 300);
  });
};

$.fn.closeDialog = function() {
  return this.each(function() {
    $(this).find('.custom-dialog-content').removeClass('open').addClass('closed');
    setTimeout(() => {
      $(this).addClass('d-none');
    }, 300);
  });
};

$(document).on('click', '[data-dismiss-dialog="close"]', function() {
  $(this).closest('.custom-dialog').closeDialog();
});
